import React, { useEffect } from 'react';

const LoadingComponent = () => {
  useEffect(() => {
    document.body.classList.add('overflow-hidden');
    document.body.classList.add('h-screen');

    return () => {
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('h-screen');
    };
  }, []);

  return (
    <div data-testid="loading" id="loading" className="w-full h-full inset-0 flex-middle-center bg-white z-max">
      <div className="w-26 h-26 rounded-lg bg-white flex-middle-center">
        <img className="animate-spin" src={require('assets/resources/Loading.png')} alt="loading" width={72} height={72} />
      </div>
    </div>
  );
};

export default React.memo(LoadingComponent);
